import script from "./AddService.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddService.vue?vue&type=script&setup=true&lang=ts"

import "./AddService.vue?vue&type=style&index=0&id=f3f87854&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3f87854"]])

export default __exports__